import { BuildFeatureItemId } from "components/BuildFeatures/BuildFeatures.types";
import { TVideoCardFeatureV2 } from "pages/LayoutComponents/VideoCardGrid/VideoCardGrid.types";

import u7PaintableCoverVideo from "../assets/related-addons/u7-paintable-cover.mp4";
import u7PaintableCoverPoster from "../assets/related-addons/u7-paintable-cover-poster.jpg";
import u7PaintableCoverPreview from "../assets/related-addons/u7-paintable-cover-preview.png";
import u6PlusCoverVideo from "../assets/related-addons/u6-plus-cover.mp4";
import u6PlusCoverPoster from "../assets/related-addons/u6-plus-cover-poster.jpg";
import u6PlusCoverPreview from "../assets/related-addons/u6-plus-cover-preview.png";
import u7ProWallPaintableVideo from "../assets/related-addons/u7-pro-wall-paintable.mp4";
import u7ProWallPaintablePoster from "../assets/related-addons/u7-pro-wall-paintable.jpg";
import u7ProWallPaintableCoverPreview from "../assets/related-addons/u7-pro-wall-paintable-cover-preview.png";
import u7ProWallFlushMountPaintableVideo from "../assets/related-addons/u7-pro-wall-flush-mount-paintable.mp4";
import u7ProWallFlushMountPaintablePoster from "../assets/related-addons/u7-pro-wall-flush-mount-paintable.jpg";
import u7ProWallPaintableFlushMountPreview from "../assets/related-addons/u7-pro-wall-paintable-flush-mount-preview.png";
import u6ExtenderCoverVideo from "../assets/related-addons/u6-extender-cover.mp4";
import u6ExtenderCoverPoster from "../assets/related-addons/u6-extender-cover-poster.jpg";
import u6ExtenderCoverPreview from "../assets/related-addons/u6-extender-cover-preview.png";
import inWallHdCoverVideo from "../assets/related-addons/in-wall-hd-cover.mp4";
import inWallHdCoverPoster from "../assets/related-addons/in-wall-hd-cover-poster.jpg";
import inWallHdCoverPreview from "../assets/related-addons/in-wall-hd-cover-preview.png";
import apArmMountVideo from "../assets/related-addons/ap-arm-mount.mp4";
import apArmMountPoster from "../assets/related-addons/ap-arm-mount.jpg";
import apArmMountPreview from "../assets/related-addons/ap-arm-mount-preview.png";
import apLiteArmMountVideo from "../assets/related-addons/ap-lite-arm-mount.mp4";
import apLiteArmMountPoster from "../assets/related-addons/ap-lite-arm-mount-poster.jpg";
import apLiteArmMountPreview from "../assets/related-addons/ap-lite-arm-mount-preview.png";
import apProMountingSystemVideo from "../assets/related-addons/ap-pro-mounting-system.mp4";
import apProMountingSystemPoster from "../assets/related-addons/ap-pro-mounting-system-poster.jpg";
import apProMountingSystemPreview from "../assets/related-addons/ap-pro-mounting-system-preview.png";
import apLiteRetrofitMountVideo from "../assets/related-addons/ap-lite-retrofit-mount.mp4";
import apLiteRetrofitMountPoster from "../assets/related-addons/ap-lite-retrofit-mount-poster.jpg";
import apLiteRetrofitMountPreview from "../assets/related-addons/ap-lite-retrofit-mount-preview.png";
import apLiteRecessedCeilingMountVideo from "../assets/related-addons/ap-lite-recessed-ceiling-mount.mp4";
import apLiteRecessedCeilingMountPoster from "../assets/related-addons/ap-lite-recessed-ceiling-mount-poster.jpg";
import apRecessedCeilingMountPreview from "../assets/related-addons/ap-recessed-ceiling-mount-preview.png";
import u7ProWallTableMountVideo from "../../../../assets/related-addons/wifi/u7-pro-wall-table-mount.mp4";
import u7ProWallTableMountPoster from "../../../../assets/related-addons/wifi/u7-pro-wall-table-mount.jpg";
import u7ProWallTableStandPreview from "../assets/related-addons/u7-pro-wall-table-stand-preview.png";
import omniAntennaDesktopStandKitVideo from "../assets/related-addons/omni-antenna-desktop-stand-kit.mp4";
import omniAntennaDesktopStandKitPoster from "../assets/related-addons/omni-antenna-desktop-stand-kit-poster.jpg";
import omniAntennaDesktopStandKitPreview from "../assets/related-addons/omni-antenna-desktop-stand-kit-preview.png";
import meshApInCeilingVideo from "../assets/related-addons/mesh-ap-in-ceiling.mp4";
import meshApInCeilingPoster from "../assets/related-addons/mesh-ap-in-ceiling-poster.jpg";
import apInCeilingMountPreview from "../assets/related-addons/ap-in-ceiling-mount-preview.png";
import poeAdapter15wVideo from "../assets/related-addons/poe-adapter-15w.mp4";
import poeAdapter15wPoster from "../assets/related-addons/poe-adapter-15w-poster.jpg";
import poeAdapter15wPreview from "../assets/related-addons/poeAdapter15w-preview.png";
import poePlusAdapter30wVideo from "../assets/related-addons/poe-plus-adapter-30w.mp4";
import poePlusAdapter30wPoster from "../assets/related-addons/poe-plus-adapter-30w-poster.jpg";
import poeAdapter30wPreview from "../assets/related-addons/poe-adapter30w-preview.png";
import poe25gPlusAdapter30wVideo from "../assets/related-addons/_2.5g-poe-plus-adapter-30w.mp4";
import poe25gPlusAdapter30wPoster from "../assets/related-addons/_2.5g-poe-plus-adapter-30w-poster.jpg";
import poePlus25GAdapter30wPreview from "../assets/related-addons/poe-plus-2-5G-adapter30w-preview.png";
import poePlusPlusAdapter60wVideo from "../assets/related-addons/poe-plus-plus-adapter-60w.mp4";
import poePlusPlusAdapter60wPoster from "../assets/related-addons/poe-plus-plus-adapter-60w-poster.jpg";
import poePlusPlusAdapterPreview from "../assets/related-addons/poe-plus-plus-adapter-preview.png";
import poe10gPlusPlusAdapter60wVideo from "../assets/related-addons/_10g-poe-plus-plus-adapter-60w.mp4";
import poe10gPlusPlusAdapter60wPoster from "../assets/related-addons/_10g-poe-plus-plus-adapter-60w-poster.jpg";
import poe10gPoeplusAdapterPreview from "../assets/related-addons/_10g-poeplusplus-adapter-preview.png";
import longRangeEthernetRepeaterVideo from "../../../../assets/related-addons/wifi/long-range-ethernet-repeater.mp4";
import longRangeEthernetRepeaterPoster from "../../../../assets/related-addons/wifi/long-range-ethernet-repeater.jpg";
import lrEthernetRepeaterPreview from "../assets/related-addons/lrEthernetRepeater-preview.png";
import wifimanWizardVideo from "../../../../assets/related-addons/wifi/wifiman-wizard.mp4";
import wifimanWizardPoster from "../../../../assets/related-addons/wifi/wifiman-wizard.jpg";
import wifimanWizardPreview from "../assets/related-addons/wifiman-wizard-preview.png";
import acMeshDualBandAntennaVideo from "../assets/related-addons/ac-mesh-dual-band-antenna.mp4";
import acMeshDualBandAntennaPoster from "../assets/related-addons/ac-mesh-dual-band-antenna-poster.jpg";
import acMeshDualBandAntennaPreview from "../assets/related-addons/ac-mesh-dual-band-antenna-preview.png";
import panelAntennaVideo from "../assets/related-addons/panel-antenna.mp4";
import panelAntennaPoster from "../assets/related-addons/panel-antenna-poster.jpg";
import panelAntennaPreview from "../assets/related-addons/panel-antenna-preview.png";
import ethernetSurgeProtectorVideo from "../../../../assets/related-addons/shared/ethernet-surge-protector.mp4";
import ethernetSurgeProtectorPoster from "../../../../assets/related-addons/shared/ethernet-surge-protector.jpg";
import ethernetSurgeProtectorPreview from "../assets/related-addons/ethernet-surge-protector-preview.png";

export const INSTALLATION_ADDONS = [
  // #############################################################################
  // COVERS
  // #############################################################################
  /**
   * U7 Paintable Cover
   */
  {
    id: "U7PaintableCover",
    title: "installationAddons.u7PaintableCover.title",
    dimensions: [
      {
        dimensionsMillimeters: "Ø217.4 x 48.3 mm",
        dimensionsInches: '(Ø8.6 x 1.9")',
      },
    ],
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.U7ProMax, label: "U7 Pro Max" },
      { id: BuildFeatureItemId.U7Pro, label: "U7 Pro" },
    ],
    description: "installationAddons.u7PaintableCover.description",
    video: {
      src: u7PaintableCoverVideo,
      poster: u7PaintableCoverPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-u7-cover`,
    },
    previewImg: u7PaintableCoverPreview,
  },
  /**
   * U6+ Cover
   */
  {
    id: "u6PlusCover",
    title: "installationAddons.u6PlusCover.title",
    description: "installationAddons.u6PlusCover.description",
    dimensions: [
      {
        dimensionsMillimeters: "Ø169.3 x 34.2 mm",
        dimensionsInches: '(Ø6.7 x 1.3")',
      },
    ],
    category: "commons.accessory",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.U6Plus, label: "U6+" },
      { id: BuildFeatureItemId.U6Lite, label: "U6 Lite" },
      { id: BuildFeatureItemId.NanoHD, label: "nanoHD" },
    ],
    video: {
      src: u6PlusCoverVideo,
      poster: u6PlusCoverPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/nhd-cover`,
    },
    previewImg: u6PlusCoverPreview,
  },
  /**
   * U7 Pro Wall Paintable Cover
   */
  {
    id: "U7ProWallPaintableCover",
    title: "installationAddons.u7ProWallPaintableCover.title",
    category: "commons.kitIncluded",
    dimensions: [
      {
        dimensionsMillimeters: "157.8 x 110.8 x 39.5 mm",
        dimensionsInches: '(6.2 x 4.4 x 1.6")',
      },
    ],
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.U7ProWall, label: "U7 Pro Wall" }],
    description: "installationAddons.u7ProWallPaintableCover.description",
    video: {
      src: u7ProWallPaintableVideo,
      poster: u7ProWallPaintablePoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-u7-pro-wall-cover`,
    },
    previewImg: u7ProWallPaintableCoverPreview,
  },
  /**
   * U7 Pro Wall Paintable Flush Mount
   */
  {
    id: "U7ProWallPaintableFlushMount",
    title: "installationAddons.u7ProWallFlushMount.title",
    category: "commons.kitIncluded",
    dimensions: [
      {
        dimensionsMillimeters: "190 x 142 x 49 mm",
        dimensionsInches: '(7.5 x 5.6 x 1.9")',
      },
    ],
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.U7ProWall, label: "U7 Pro Wall" }],
    description: "installationAddons.u7ProWallFlushMount.description",
    video: {
      src: u7ProWallFlushMountPaintableVideo,
      poster: u7ProWallFlushMountPaintablePoster,
    },
    learnMoreLink: { path: `/unifi/other/uacc-u7-pro-wall-fm` },
    previewImg: u7ProWallPaintableFlushMountPreview,
  },
  /**
   * U6 Extender Cover
   */
  {
    id: "U6ExtenderCover",
    title: "installationAddons.u6ExtenderCover.title",
    dimensions: [
      {
        dimensionsMillimeters: "172 x 113.6 x 32.7 mm",
        dimensionsInches: '(6.8 x 4.5 x 1.3")',
      },
    ],
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.U6Extender, label: "Beacon HD" },
      { id: BuildFeatureItemId.U6Extender, label: "U6 Extender" },
    ],
    description: "installationAddons.u6ExtenderCover.description",
    video: {
      src: u6ExtenderCoverVideo,
      poster: u6ExtenderCoverPoster,
    },
    learnMoreLink: {
      path: `/unifi/other/cover-for-unifi-access-point-beaconhd-3-pack`,
    },
    previewImg: u6ExtenderCoverPreview,
  },
  /**
   * In-Wall HD Cover
   */
  {
    id: "InWallHDCover",
    title: "installationAddons.inWallHDCover.title",
    category: "commons.kitIncluded",
    dimensions: [
      {
        dimensionsMillimeters: "145.6 x 93.6 x 27.7 mm",
        dimensionsInches: '(5.7 x 3.7 x 1.1")',
      },
    ],
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.U7InWall, label: "U7 Pro Wall" }],
    description: "installationAddons.inWallHDCover.description",
    video: {
      src: inWallHdCoverVideo,
      poster: inWallHdCoverPoster,
    },
    learnMoreLink: { path: `/unifi/other/iw-hd-cover` },
    previewImg: inWallHdCoverPreview,
  },

  // #############################################################################
  // MOUNTS, MOUNTING
  // #############################################################################
  /**
   * AP Arm Mount
   */
  {
    id: "APArmMount",
    title: "installationAddons.apArmMount.title",
    category: "commons.accessory",
    dimensions: [
      {
        dimensionsMillimeters: "200.5 x 175.1 x 31.2 mm",
        dimensionsInches: '(7.9 x 6.9 x 1.2")',
      },
    ],
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.U7Pro, label: "U7 Pro" },
      { id: BuildFeatureItemId.U7ProMax, label: "U7 Pro Max" },
      { id: BuildFeatureItemId.U6Pro, label: "U6 Pro" },
      { id: BuildFeatureItemId.U6Enterprise, label: "U6 Enterprise" },
      { id: BuildFeatureItemId.U6LongRange, label: "U6 Long Range" },
    ],
    description: "installationAddons.apArmMount.description",
    video: {
      src: apArmMountVideo,
      poster: apArmMountPoster,
    },
    learnMoreLink: {
      path: `/unifi/other/uacc-ap-am`,
    },
    previewImg: apArmMountPreview,
  },
  /**
   * AP Lite Arm Mount
   */
  {
    id: "APLiteArmMount",
    title: "installationAddons.apLiteArmMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.U6Plus, label: "U6+" },
      { id: BuildFeatureItemId.U6Lite, label: "U6 Lite" },
      { id: BuildFeatureItemId.NanoHD, label: "nanoHD" },
      { id: BuildFeatureItemId.ACLite, label: "AC Lite" },
    ],
    description: "installationAddons.apLiteArmMount.description",
    dimensions: [
      {
        dimensionsMillimeters: "149 x 89 x 29 mm",
        dimensionsInches: '(5.9 x 3.5 x 1.1")',
      },
    ],
    video: {
      src: apLiteArmMountVideo,
      poster: apLiteArmMountPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-lite-ap-am`,
    },
    previewImg: apLiteArmMountPreview,
  },
  /**
   * AP Pro Mounting System
   */
  {
    id: "APProMountingSystem",
    title: "installationAddons.apProMountSystem.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.U7Pro, label: "U7 Pro" },
      { id: BuildFeatureItemId.U7ProMax, label: "U7 Pro Max" },
      { id: BuildFeatureItemId.U6Pro, label: "U6 Pro" },
      { id: BuildFeatureItemId.U6LongRange, label: "U6 Long-Range" },
    ],
    description: "installationAddons.apProMountSystem.description",
    dimensions: [
      {
        dimensionsMillimeters: "175.6 mm",
        dimensionsInches: '(6.9")',
      },
    ],
    video: {
      src: apProMountingSystemVideo,
      poster: apProMountingSystemPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/unifi-professional-mounting-system`,
    },
    previewImg: apProMountingSystemPreview,
  },
  /**
   * AP Lite Retrofit Mount
   */
  {
    id: "APLiteRetrofitMount",
    title: "installationAddons.apLiteRetrofitMount.title",
    dimensions: [
      {
        dimensionsMillimeters: "Ø187.8 x 16.7 mm",
        dimensionsInches: '(Ø7.4 x 0.7")',
      },
    ],
    category: "commons.accessory",
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.U6Plus, label: "U6+" },
      { id: BuildFeatureItemId.U6Lite, label: "U6 Lite" },
      { id: BuildFeatureItemId.NanoHD, label: "nanoHD" },
    ],
    description: "installationAddons.apLiteRetrofitMount.description",
    video: {
      src: apLiteRetrofitMountVideo,
      poster: apLiteRetrofitMountPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/nanohd-retrofit-3`,
    },
    previewImg: apLiteRetrofitMountPreview,
  },
  /**
   * Compact Flagship AP Recessed Ceiling Mount
   */
  {
    id: "APLiteRecessedCeilingMount",
    title: "installationAddons.apLiteRecessedMount.title",
    category: "commons.kitIncluded",
    dimensions: [
      {
        dimensionsMillimeters: "Ø210 x 20.6 mm",
        dimensionsInches: '(Ø8.3 x 0.8")',
      },
    ],
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.U6Plus, label: "U6+" },
      { id: BuildFeatureItemId.U6Lite, label: "U6 Lite" },
      { id: BuildFeatureItemId.NanoHD, label: "nanoHD" },
      { id: BuildFeatureItemId.ACLite, label: "AC Lite" },
    ],
    description: "installationAddons.apLiteRecessedMount.description",
    video: {
      src: apLiteRecessedCeilingMountVideo,
      poster: apLiteRecessedCeilingMountPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/nanohd-rcm-3`,
    },
    previewImg: apRecessedCeilingMountPreview,
  },
  /**
   * U7 Pro Wall Table Stand
   */
  {
    id: "U7ProWallTableStand",
    title: "installationAddons.u7ProWallTableStand.title",
    category: "commons.accessory",
    dimensions: [
      {
        dimensionsMillimeters: "92.1 x 80 x 183.6 mm",
        dimensionsInches: '(3.6 x 3.1 x 7.2")',
      },
    ],
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.U7ProWall, label: "U7 Pro Wall" }],
    description: "installationAddons.u7ProWallTableStand.description",
    video: {
      src: u7ProWallTableMountVideo,
      poster: u7ProWallTableMountPoster,
    },
    learnMoreLink: { path: `/unifi/other/uacc-u7-pro-wall-ts` },
    previewImg: u7ProWallTableStandPreview,
  },
  /**
   * Omni Antenna & Desktop Stand Kit
   */
  {
    id: "OmniAntennaDesktopStandKit",
    title: "installationAddons.omniAntennaStandKit.title",
    category: "commons.kitIncluded",
    dimensions: [
      {
        label: "installationAddons.omniAntennaStandKit.antenna.dim.label",
        dimensionsMillimeters: "154 x 15 x 15 mm",
        dimensionsInches: '(6.1 x 0.6 x 0.6")',
      },
      {
        label: "installationAddons.omniAntennaStandKit.stand.dim.label",
        dimensionsMillimeters: "92.7 x 41.8 x 58.8 mm",
        dimensionsInches: '(3.6 x 1.6 x 2.3")',
      },
    ],
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.SwissArmyKnife, label: "Swiss Army Knife" },
    ],
    description: "installationAddons.omniAntennaStandKit.description",
    video: {
      src: omniAntennaDesktopStandKitVideo,
      poster: omniAntennaDesktopStandKitPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-uk-ultra-omni-antenna`,
    },
    previewImg: omniAntennaDesktopStandKitPreview,
  },
  /**
   * AP In-Ceiling Mount
   */
  {
    id: "APInCeilingMount",
    title: "installationAddons.apiInCeilingMount.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.U6Mesh, label: "U6 Mesh" }],
    description: "installationAddons.apiInCeilingMount.description",
    dimensions: [
      {
        dimensionsMillimeters: "Ø87.1 x 112 mm",
        dimensionsInches: '(Ø3.4 x 4.4")',
      },
    ],
    video: {
      src: meshApInCeilingVideo,
      poster: meshApInCeilingPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/flexhd-cm-3`,
    },
    previewImg: apInCeilingMountPreview,
  },
  // #############################################################################
  // ADAPTERS
  // #############################################################################
  /**
   * PoE Adapter (15W)
   */
  {
    id: "poeAdapter15w",
    title: "installationAddons.poeAdapter15w.title",
    description: "installationAddons.poeAdapter15w.description",
    category: "commons.installationAddOn",
    tags: [
      { id: BuildFeatureItemId.U7LR, label: "U7 Long-Range" },
      { id: BuildFeatureItemId.U7ProWall, label: "U7 Pro Wall" },
    ],
    shouldDisplayTagNames: false,
    dimensions: [
      {
        dimensionsMillimeters: "86 x 46 x 33 mm",
        dimensionsInches: '(3.4 x 1.8 x 1.3")',
      },
    ],
    video: {
      src: poeAdapter15wVideo,
      poster: poeAdapter15wPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/u-poe-af`,
    },
    previewImg: poeAdapter15wPreview,
  },
  /**
   * PoE+ Adapter (30W)
   */
  {
    id: "poePlusAdapter30w",
    title: "installationAddons.poePlusAdapter30w.title",
    description: "installationAddons.poePlusAdapter30w.description",
    dimensions: [
      {
        dimensionsMillimeters: "93 x 62 x 35 mm",
        dimensionsInches: '(3.7 x 2.4 x 1.4")',
      },
    ],
    category: "commons.installationAddOn",
    tags: [
      { id: BuildFeatureItemId.U7LR, label: "U7 Long-Range" },
      { id: BuildFeatureItemId.U7ProWall, label: "U7 Pro Wall" },
    ],
    shouldDisplayTagNames: false,
    video: {
      src: poePlusAdapter30wVideo,
      poster: poePlusAdapter30wPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/u-poe-plus`,
    },
    previewImg: poeAdapter30wPreview,
  },
  /**
   * 2.5G PoE+ Adapter (30W)
   */
  {
    id: "poePlus2-5GAdapter30w",
    title: "installationAddons.poePlus2-5GAdapter30w.title",
    description: "installationAddons.poePlus2-5GAdapter30w.description",
    dimensions: [
      {
        dimensionsMillimeters: "93 x 62 x 35 mm",
        dimensionsInches: '(3.7 x 2.4 x 1.4")',
      },
    ],
    category: "commons.installationAddOn",
    tags: [
      { id: BuildFeatureItemId.U7LR, label: "U7 Long-Range" },
      { id: BuildFeatureItemId.U7ProWall, label: "U7 Pro Wall" },
    ],
    shouldDisplayTagNames: false,
    video: {
      src: poe25gPlusAdapter30wVideo,
      poster: poe25gPlusAdapter30wPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-poe-plus-2-5g`,
    },
    previewImg: poePlus25GAdapter30wPreview,
  },
  /**
   * PoE++ Adapter (60W)
   */
  {
    id: "PoE++Adapter",
    title: "installationAddons.poePlusPlusAdapter.title",
    dimensions: [
      {
        dimensionsMillimeters: "106 x 63 x 34 mm",
        dimensionsInches: '(4.2 x 2.5 x 1.3")',
      },
    ],
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.E7Campus, label: "E7 Campus" },
      { id: BuildFeatureItemId.E7, label: "E7" },
      { id: BuildFeatureItemId.U7ProWall, label: "U7 Pro Wall" },
    ],
    description: "installationAddons.poePlusPlusAdapter.description",
    video: {
      src: poePlusPlusAdapter60wVideo,
      poster: poePlusPlusAdapter60wPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/u-poe-plus-plus`,
    },
    previewImg: poePlusPlusAdapterPreview,
  },
  /**
   * 10G PoE++ Adapter (60W)
   */
  {
    id: "10GPoE++Adapter",
    title: "installationAddons.10GPoePlusPlusAdapter.title",
    description: "installationAddons.10GPoePlusPlusAdapter.description",
    dimensions: [
      {
        dimensionsMillimeters: "106 x 63 x 34 mm",
        dimensionsInches: '(4.2 x 2.5 x 1.3")',
      },
    ],
    category: "commons.installationAddOn",
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.E7Campus, label: "E7 Campus" },
      { id: BuildFeatureItemId.E7, label: "E7" },
      { id: BuildFeatureItemId.U7ProWall, label: "U7 Pro Wall" },
    ],
    video: {
      src: poe10gPlusPlusAdapter60wVideo,
      poster: poe10gPlusPlusAdapter60wPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-poe-plus-plus-10g`,
    },
    previewImg: poe10gPoeplusAdapterPreview,
  },
  // #############################################################################
  // MISCELLANEOUS
  // #############################################################################
  /**
   * Long-Range Ethernet Repeater
   */
  {
    id: "lrEthernetRepeater",
    title: "installationAddons.lrEthernetRepeater.title",
    description: "installationAddons.lrEthernetRepeater.description",
    dimensions: [
      {
        dimensionsMillimeters: "196.5 x 93.5 x 39 mm",
        dimensionsInches: '(7.7 x 3.7 x 1.5")',
      },
    ],
    category: "commons.installationAddOn",
    tags: [{ id: BuildFeatureItemId.U7LR, label: "U7 Long-Range" }],
    shouldDisplayTagNames: false,
    video: {
      src: longRangeEthernetRepeaterVideo,
      poster: longRangeEthernetRepeaterPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/uacc-lre`,
    },
    previewImg: lrEthernetRepeaterPreview,
  },
  /**
   * WiFiMan Wizard
   */
  {
    id: "WiFiManWizard",
    title: "installationAddons.wifimanWizard.title",
    category: "commons.installationAddOn",
    dimensions: [
      {
        dimensionsMillimeters: "78.5 x 50.5 x 7.9 mm",
        dimensionsInches: '(3.1 x 2 x 0.3")',
      },
    ],
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.E7Campus, label: "E7 Campus" },
      { id: BuildFeatureItemId.E7, label: "E7" },
      { id: BuildFeatureItemId.U7ProWall, label: "U7 Pro Wall" },
    ],
    description: "installationAddons.wifimanWizard.description",
    video: {
      src: wifimanWizardVideo,
      poster: wifimanWizardPoster,
    },
    learnMoreLink: { path: `/unifi/other/wm-w` },
    previewImg: wifimanWizardPreview,
  },
  /**
   * AC Mesh Dual-Band Antenna
   */
  {
    id: "ACMeshDualBandAntenna",
    title: "installationAddons.acMeshDualBandAntenna.title",
    category: "commons.kitIncluded",
    shouldDisplayTagNames: true,
    tags: [{ id: BuildFeatureItemId.ACMesh, label: "AC Mesh" }],
    description: "installationAddons.acMeshDualBandAntenna.description",
    dimensions: [
      {
        dimensionsMillimeters: "201.3 x 128 x 32.5 mm",
        dimensionsInches: '(7.9 x 5 x 1.3")',
      },
    ],
    video: {
      src: acMeshDualBandAntennaVideo,
      poster: acMeshDualBandAntennaPoster,
    },
    learnMoreLink: { path: `/unifi/other/uma-d` },
    previewImg: acMeshDualBandAntennaPreview,
  },
  /**
   * Panel Antenna
   */
  {
    id: "PanelAntenna",
    title: "installationAddons.panelAntenna.title",
    category: "commons.accessory",
    dimensions: [
      {
        dimensionsMillimeters: "138 x 207 x 43 mm",
        dimensionsInches: '(5.4 x 8.1 x 1.7")',
      },
    ],
    shouldDisplayTagNames: true,
    tags: [
      { id: BuildFeatureItemId.SwissArmyKnife, label: "Swiss Army Knife" },
    ],
    description: "installationAddons.panelAntenna.description",
    video: {
      src: panelAntennaVideo,
      poster: panelAntennaPoster,
    },
    learnMoreLink: { path: `/unifi/other/uacc-uk-ultra-panel-antenna` },
    previewImg: panelAntennaPreview,
  },
  /**
   * Ethernet Surge Protector
   */
  {
    id: "EthernetSurgeProtector",
    title: "installationAddons.ethernetSurgeProtector.title",
    category: "commons.esdProtection",
    dimensions: [
      {
        dimensionsMillimeters: "91 x 61 x 32.5 mm",
        dimensionsInches: '(3.6 x 2.4 x 1.3")',
      },
    ],
    shouldDisplayTagNames: false,
    tags: [
      { id: BuildFeatureItemId.U7Outdoor, label: "U7 Outdoor" },
      { id: BuildFeatureItemId.U6MeshPro, label: "U6 Mesh Pro" },
      { id: BuildFeatureItemId.U6Mesh, label: "U6 Mesh" },
      { id: BuildFeatureItemId.ACMeshPro, label: "AC Mesh Pro" },
      { id: BuildFeatureItemId.ACMesh, label: "AC Mesh" },
      { id: BuildFeatureItemId.SwissArmyKnife, label: "Swiss Army Knife" },
      { id: BuildFeatureItemId.BuildingBridgeXG, label: "Building Bridge XG" },
      { id: BuildFeatureItemId.BuildingBridge, label: "Building Bridge" },
      { id: BuildFeatureItemId.DeviceBridgePro, label: "Device Bridge Pro" },
      { id: BuildFeatureItemId.DeviceBridge, label: "Device Bridge" },
    ],
    description: "installationAddons.ethernetSurgeProtector.description",
    video: {
      src: ethernetSurgeProtectorVideo,
      poster: ethernetSurgeProtectorPoster,
    },
    learnMoreLink: {
      path: `/unifi/accessories/ethernet-surge-protector`,
    },
    previewImg: ethernetSurgeProtectorPreview,
  },
] satisfies TVideoCardFeatureV2[];
